export default __webpack_public_path__ + "static/media/color-science.d3b125f9.svg";